import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { FragmentNames, ScoreDiniListAliases } from '../../../../codegen/index';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { ScoreAndIndexesService } from '../../scores-list/scores-list-service';
import { ScoresAndIndexesStatusType } from '../../score-types';

@Controller ({ component: ScoreDiniListAliases.LAYOUT_SCORE_DINI_LIST, fragment: FragmentNames.SCORE_DINI_LIST })
export default class ScoreDiniListController extends BaseController {

  @Inject(ScoreDiniListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScoreDiniListAliases.LAYOUT_SCORE_DINI_LIST })
  handleMountLayoutScoreDini(): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    this.panelGlobalActions.setVisible(allowInfo);
  }

  @OnClick({ target: ScoreDiniListAliases.ADD_SCORE_DINI_CUSTOM_DYNAMIC_BUTTON })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.SCORE_DINI_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: ScoreDiniListAliases.DECK_SCORE_DINI })
  handleOnClickCard(event: ClickEvent): void {
    const { idScoreIndexes, status } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    const accessViewer = ((status === ScoresAndIndexesStatusType.ACTIVE) || (!allowInfo));
    const route = accessViewer ? ApplicationRoute.SCORE_DINI_VIEWER : ApplicationRoute.SCORE_DINI_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idScoreIndexes,
      patientId,
    });
  }
}
